import React, { Component } from 'react';
import {getReportViewerDetails,validateCSQuery} from '../../../data/report_viewer_api';
import {Button, Modal,TransitionablePortal, Header, Icon, Input, Image, Message, Popup, Segment, Divider} from "semantic-ui-react";
import Loader from '../../universal/loader';
import RoomInfoContainer from "./room_info_container"
import GeneralInfoContainer from "./general_info_container"
import moment from "moment"
import { handleFileDownload } from "../../../../src/utils/download_file";
import { BASE_URL } from "../../../constants/app_routes";
import DownloadingIntent from "../../universal/toast";
import AddCustomerService from '../../inspection/add_customer_service';
import ReportViewerContainer from './report_viewer_container';

class ReportViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inspectionId:this.props.match.params.inspectionId,
            token: this.props.match.params.token,
            loading: true,
            error: false,
            errormessage: undefined,
            reportDetails: undefined,
            images: [],
            currentImage: undefined,
          currentImageId: undefined,
          submitted:false,
            showModal: false,
            zoom: 100,
          showCS: false,
          showCSConfirmation: false,
          showValidationMessage:false
            
        }
    }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyPress);
    const query = new URLSearchParams(this.props.location.search);
    let data = {}
    
    for (let params of query.entries()) {
      data[params[0]] = params[1];
    }
      if (data.query_validation) {
        validateCSQuery(data.query_id, data.query_validation).then((response) => {
            this.setState({ showValidationMessage: true, validationMessage:response.message?response.message:response.data.message })
            setTimeout(() => { this.setState({ showValidationMessage: false, validationMessage:null })},15000)
        })
      }
      this.refreshReportViewerData()
    }

  componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyPress);
    }

    
    refreshReportViewerData = async () => {
      getReportViewerDetails(this.state.inspectionId, this.state.token).then((response) => {
        if (response.status === 200) {
            if (response.data.report) {
                this.setState({ loading: false, reportDetails: response.data.report });
            }
            else if(response.data.inspection){this.setState({ loading: false, reportDetails: response.data.inspection });}
        }
        else if (response.status === 412) { this.setState({ loading: false, error: true, errormessage:response.message }) };
    }
    )
    }
    addToImagesList = (image) =>{
        if (image.image_path) {
            let newImages = this.state.images
            newImages.push(image)
            this.setState({ images: newImages })
        }else{}
    }
    getIndexOfObjectIfExists = (arrObj, searchId) => {
        for (let i = 0; i < arrObj.length; i++) {
          if (arrObj[i]['id'] === searchId) {
            return i;
          }
        }
        return -1;
    };
    setCurrentImage = (image) => {
        var imageID = this.getIndexOfObjectIfExists(this.state.images,image["id"])
        this.setState({ currentImage: image, showModal: true, currentImageId: imageID })
    }
    nextImage = () => {
        var newImageID = this.state.currentImageId + 1 
        this.setState({ currentImage: this.state.images[newImageID],currentImageId: newImageID})
      }
      prevImage = () => {
        this.setState({ currentImage: this.state.images[this.state.currentImageId -1],currentImageId: this.state.currentImageId -1})
      }
    toggleZoom = () => {
        this.state.zoom == 100 ?this.setState({ zoom: 200 }) : this.setState({zoom:100})
    }
    handleDownload = async (id, token) => {
      if(!this.state.isDownloading) {
      this.setState({isDownloading: true, showDownload: true});
      let URL = BASE_URL + "/report/download_with_token/" + id + "/" + token;
      //if(reportDetail['report_pdf_path']){
      //    URL = reportDetail['report_pdf_path'];
      //}
      let fileName = this.state.reportDetails.filename;
      await handleFileDownload(URL, fileName);
      this.setState({isDownloading: false});
      }
    };
  showAddCS = () => {
    this.setState({showCS:true})
  }
  hideAddCS = () => {
    this.setState({loading: true, reportDetails: undefined,showCS:false })
    this.refreshReportViewerData()
  }
  showConfirmation = async () => {
    this.setState({ showCSConfirmation: true,showCS:false,submitted:true })
    setTimeout(() => { this.setState({ showCSConfirmation: false })},15000)
  }

  handleKeyPress = (event) => {

    if (event.key === 'ArrowLeft' && this.state.currentImageId > 0) {
      this.prevImage();
    } else if (event.key === 'ArrowRight' && this.state.currentImageId +1 < this.state.images.length) {
      this.nextImage();
    }
  };
    render() {
        const inspectionTypes = {"inv": "Inventory", "ci": "Check-In", "co": "Check-Out", "inv/ci": "Inventory/Check-In", "pv":"Property Visit"};
        return(
          <div>{this.state.showCSConfirmation && <div className="pad-all"><Message align="center" header="Customer Service submitted, check the email for identity confirmation link. If you do not receive it, email us at customer.service@hinchpm.com to validate your identity" info
                  onDismiss={() => {
                      this.setState({showCSConfirmation: false})
            }} /></div>}
            {this.state.showValidationMessage && <div className="pad-all"><Message align="center" header={this.state.validationMessage } info
                  onDismiss={() => {
                      this.setState({showCSConfirmation: false})
                  }}/></div>}
            {this.state.loading ? <Loader contain={true} customText={"Loading Online Report Viewer"} /> : <React.Fragment>
            <Modal size="fullscreen" open={this.state.showCS} >
              <Modal.Content>
            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                   this.hideAddCS()
                                }}><Icon name="close"/></Button>
                            </div>
              {this.state.reportDetails && <AddCustomerService reportId={this.state.reportDetails.id}inspectionId={this.state.inspectionId} token={this.state.token} closeWindow={()=>{this.refreshReportViewerData()}}refreshData={() =>{this.showConfirmation()}}></AddCustomerService>}</Modal.Content></Modal>    
            <TransitionablePortal transition={{ animation: "scale", duration: 250 }} open={this.state.showModal} >
          <Modal onClose={() => this.setState({ showModal: false })} open size="fullscreen"style={{ height: "95%",overflow:"scroll"}}>
            <Modal.Content image style={{ height: "100%" }}>
              <div className="modal-close-button"> 
              <Button basic compact >You can navigate using the keyboard arrow keys</Button>         
                <Button icon onClick={(e) => {this.toggleZoom();}}>
                  <Icon name="search"/>
                  {this.state.zoom}%
                  </Button>
                  <Button disabled={!(this.state.currentImageId > 0)}icon onClick={(e) => {this.prevImage();}}>
                  <Icon name="left arrow" />
                  </Button> 
                  <Button disabled={!(this.state.currentImageId +1 < this.state.images.length )}icon onClick={(e) => { this.nextImage(); }}> 
                 <Icon name="right arrow" />
                </Button> 
                <Button negative icon onClick={(e) => { this.setState({ showModal: false }); }} >
                  <Icon name="close" />
                </Button>
              </div>
            <Image rounded centered style={{ height: this.state.zoom + "%", width: "auto",maxWidth:this.state.zoom+"%" }} src={this.state.currentImage? this.state.currentImage.image_path:null} />
            </Modal.Content>
          </Modal>
        </TransitionablePortal>
                {this.state.error ? <React.Fragment>
                    <Message size='mini' negative onDismiss={() => {this.setState({error: false})}}>
                <Message.Header>{"Error acessing Online Report"}</Message.Header>
                <p>{this.state.errormessage}</p>
                    </Message><h1 align="center">Something Went Wrong!</h1></React.Fragment> : null}
                {this.state.reportDetails ? <div>
                    <Divider horizontal id="top">
                        <Header as='h4'>
                            <Icon name='home' />
                            {this.state.reportDetails.address} | {inspectionTypes[this.state.reportDetails.inspection_type]} | {moment(this.state.reportDetails.inspection_date, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY")}
                  </Header>
              </Divider>
              {this.state.reportDetails.report_type != "custom" ? <div>{!this.state.showCS && <Segment className="viewer-content"><Segment textAlign="center"><Button onClick={() => { this.handleDownload(this.state.inspectionId, this.state.token) }}>Download PDF</Button>
                  <Button disabled={this.state.submitted} primary onClick={() => { this.showAddCS() }}>Submit Comments/Images</Button></Segment>
                  <ReportViewerContainer setCurrentImage={this.setCurrentImage} addToImagesList={this.addToImagesList} reportDetails={this.state.reportDetails}></ReportViewerContainer>
                <GeneralInfoContainer  setCurrentImage={this.setCurrentImage} addToImagesList={this.addToImagesList} reportDetails={this.state.reportDetails} />
                {/* {this.state.reportDetails.rooms.map((room) => {
                    return <RoomInfoContainer setCurrentImage={this.setCurrentImage} addToImagesList={this.addToImagesList} key={room.client_id} room={room} reportType={this.state.reportDetails.report_type} />
                  })} */}
              </Segment>}</div> : <Segment className="viewer-content"><Segment textAlign="center"><Button disabled={this.state.submitted} primary onClick={() => { this.showAddCS() }}>Submit Comments/Images</Button></Segment>{!this.state.showCS && <GeneralInfoContainer reportDetails={this.state.reportDetails} addToImagesList={this.addToImagesList} setCurrentImage={this.setCurrentImage} />}</Segment>}
                </div> : null}</React.Fragment>}{this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading} />} </div>)
    }
}

export default ReportViewer


// WEBPACK FOOTER //
// ./src/views/report/report_viewer/index.js